var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldSecurity = function SvgShieldSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.616 2.045 5.042 3.768c-1.054.395-1.916 1.641-1.916 2.76v6.81c0 1.082.715 2.503 1.586 3.154l3.941 2.942c1.293.972 3.42.972 4.712 0l3.942-2.942c.87-.651 1.586-2.072 1.586-3.154v-6.81c0-1.128-.862-2.375-1.916-2.769l-4.574-1.714c-.78-.284-2.026-.284-2.787 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11 11.46a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667M11 11.457v2.75"
  })));
};
export default SvgShieldSecurity;